module.exports = __webpack_public_path__ + "img/success-item.88e70578.png";